export function htmlFeeExternal() {
  return (
    <>
      <hr />
      <h5>Taxas Externas da Plataforma</h5>
      <p>
        Em nossa plataforma, algumas transações estão sujeitas a taxas externas
        cobradas por terceiros, como gateways de pagamento e bancos. Essas taxas
        variam de acordo com o meio de pagamento utilizado e as regras das
        instituições financeiras. Abaixo estão os principais tipos de taxas
        externas que podem ser aplicadas:
      </p>

      <h4>1. Taxas de Gateway de Pagamento</h4>
      <p>
        Os gateways de pagamento são responsáveis por processar transações
        financeiras entre clientes e vendedores. Eles podem cobrar diferentes
        tipos de taxas, como:
      </p>
      <ul>
        <li>
          <strong>Taxa por transação:</strong> Uma porcentagem do valor da
          compra, geralmente entre 1,5% e 5%.
        </li>
        <li>
          <strong>Tarifa fixa:</strong> Alguns gateways cobram um valor fixo por
          transação, além da taxa percentual.
        </li>
        <li>
          <strong>Taxa de chargeback:</strong> Caso ocorra uma contestação da
          compra, o gateway pode cobrar uma taxa extra.
        </li>
      </ul>

      <h4>2. Taxas Bancárias</h4>
      <p>
        As transferências de valores para contas bancárias também podem estar
        sujeitas a taxas, como:
      </p>
      <ul>
        <li>
          <strong>TED/DOC:</strong> Algumas instituições cobram uma tarifa para
          transferências bancárias.
        </li>
        <li>
          <strong>Taxas de saque:</strong> Caso o saldo seja transferido para
          uma conta bancária ou sacado em espécie, pode haver cobranças
          adicionais.
        </li>
      </ul>

      <h4>3. Taxas de Conversão de Moeda</h4>
      <p>
        Para transações internacionais ou pagamentos em diferentes moedas, pode
        haver cobrança de taxas de câmbio e conversão, que variam conforme o
        serviço utilizado.
      </p>

      <p>
        É importante verificar as condições e valores dessas taxas antes de
        realizar transações na plataforma.
      </p>
    </>
  );
}
